<template>
  <div class="login">
    <form @submit.prevent="Login">
      <label>Email:</label>
      <input type="email" required v-model="email">
      <label>Password:</label>
      <input type="password" required v-model="password">
      <div v-if="passwordError" class="error">{{ passwordError }}</div>
      <input type="Submit" value="Log in">
      <p><router-link to="Signup">Create account</router-link></p>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue'
import { getAuth, signInWithEmailAndPassword } from "firebase/auth"

export default {
  setup(){
    const email = ref("")
    const password = ref("")
    const passwordError = ref("")

    const Login = () => {
      const auth = getAuth()
      
      signInWithEmailAndPassword(auth, email.value, password.value)
      .then((userCredential) => {
        // Signed in successfully
        const user = userCredential.user
        store.dispatch('setCurrentUser', user)
      })
      .catch((error) => {
        //const errorCode = error.code
        //const errorMessage = error.message
        passwordError.value = error.code
        });
    }

    return {
      Login,
      email,
      password,
      passwordError
    }
  },
}
</script>

<style scoped>
.login {
  max-width: 420px;
  margin: 30px auto;
  background: white;
  text-align: left;
  padding: 40px;
  border-radius: 10px;
}
label {
  color: #1ba098;
  display: inline-block;
  margin: 25px 0 15px;
  font-size: 0.6em;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
}
input {
  display: block;
  padding: 10px 6px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-bottom: 1px solid #ddd;
  color: #7f94a2;
}
input[type="submit"] {
  background: #1ba098;
  border: 0;
  padding: 10px 20px;
  margin-top: 20px;
  color: white;
  border-radius: 20px;
}
input[type="submit"]:hover {
  background: #deb992;
}
.error {
  color: #ff0062;
  margin-top: 10px;
  font-size: 0.8em;
  font-weight: bold;
}
</style>